(function() {
  /* AJAX sin reload (P3.5-7): cambios via /cart/change.js + re-render de la
     sección con Sections API. Eventos delegados en document para sobrevivir
     al reemplazo del DOM. */
  if (!document.querySelector('[data-cart-section]')) return;

  var pending = false;

  function getSection() {
    return document.querySelector('[data-cart-section]');
  }

  function getSectionId() {
    var wrapper = getSection().closest('.shopify-section');
    return wrapper ? wrapper.id.replace('shopify-section-', '') : null;
  }

  function showError(message) {
    var el = getSection().querySelector('[data-cart-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function rerenderSection() {
    var sectionId = getSectionId();
    if (!sectionId) {
      window.location.reload();
      return Promise.resolve();
    }
    return fetch(window.location.pathname + '?section_id=' + sectionId)
      .then(function(r) {
        if (!r.ok) throw new Error('Section render failed');
        return r.text();
      })
      .then(function(html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var fresh = temp.querySelector('[data-cart-section]');
        if (fresh) getSection().replaceWith(fresh);
      })
      .catch(function() {
        window.location.reload();
      });
  }

  /* ===== Nota del pedido =====
     La sección se re-renderiza entera tras cada cambio de cantidad, así que un
     textarea sin persistir se borraría. Guardarla en el carrito real es lo que
     hace que el texto sobreviva: el Liquid la vuelve a pintar desde el
     servidor. */
  var noteTimer = null;
  var notePending = null;
  var noteSaved = null; // último valor que ya está en el carrito

  function saveNote(value) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: value })
    }).catch(function() {});
  }

  /* Persiste lo que haya en cola. cart.js la llama antes de tocar cantidades
     (también desde el mini-cart, que re-renderiza esta página). */
  function flushNote() {
    if (notePending === null) return Promise.resolve();
    clearTimeout(noteTimer);
    var value = notePending;
    notePending = null;
    /* El blur dispara aunque el usuario no haya escrito → sin esto, salir del
       campo mandaba un POST reescribiendo la nota con lo mismo. */
    if (value === noteSaved) return Promise.resolve();
    noteSaved = value;
    return saveNote(value);
  }
  window.flushCartNote = flushNote;

  function noteTarget(e) {
    return e.target && e.target.closest ? e.target.closest('[data-cart-note]') : null;
  }

  /* Baseline al entrar al campo: lo que ya está en el carrito. focus y blur no
     burbujean → captura. */
  document.addEventListener('focus', function(e) {
    var ta = noteTarget(e);
    if (ta && noteSaved === null) noteSaved = ta.value;
  }, true);

  document.addEventListener('input', function(e) {
    var ta = noteTarget(e);
    if (!ta) return;
    notePending = ta.value;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(flushNote, 600);
  });

  /* Cubre escribir y saltar directo al botón de checkout sin esperar el debounce. */
  document.addEventListener('blur', function(e) {
    var ta = noteTarget(e);
    if (!ta) return;
    notePending = ta.value;
    flushNote();
  }, true);

  /* La sección cart-accessories agrega productos y dispara 'cart:refresh'
     para que el listado del carrito se re-renderice. */
  document.addEventListener('cart:refresh', function() {
    rerenderSection();
  });

  function updateCartItem(key, quantity) {
    if (pending) return;
    pending = true;
    getSection().classList.add('is-updating');

    /* La nota pendiente se persiste ANTES: rerenderSection() repinta el
       textarea con la nota del carrito y borraría lo recién escrito. */
    flushNote()
    .then(function() {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
    })
    .then(function(r) {
      if (!r.ok) {
        return r.json().then(function(err) {
          throw new Error(err && err.description ? err.description : 'Error');
        });
      }
      return r.json();
    })
    .then(function(cart) {
      /* Badge del header */
      document.querySelectorAll('[data-cart-count]').forEach(function(el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
      return rerenderSection();
    })
    .then(function() {
      /* Sincroniza el drawer del mini-cart con el cambio hecho en /cart */
      if (window.refreshMiniCart) window.refreshMiniCart();
    })
    .catch(function(error) {
      return rerenderSection().then(function() {
        showError(error.message);
      });
    })
    .finally(function() {
      pending = false;
      var section = getSection();
      if (section) section.classList.remove('is-updating');
    });
  }

  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-cart-section]')) return;

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var key = qtyBtn.dataset.lineKey;
      var input = getSection().querySelector('[data-qty-input][data-line-key="' + key + '"]');
      if (!input) return;
      var val = parseInt(input.value) || 1;
      var change = parseInt(qtyBtn.dataset.qtyChange);
      var newVal = Math.max(0, val + change);
      input.value = newVal;
      updateCartItem(key, newVal);
      return;
    }

    var removeBtn = e.target.closest('[data-remove-item]');
    if (removeBtn) {
      updateCartItem(removeBtn.dataset.lineKey, 0);
    }
  });

  document.addEventListener('change', function(e) {
    if (!e.target.closest('[data-cart-section]')) return;
    var input = e.target.closest('[data-qty-input]');
    if (input) {
      var val = parseInt(input.value);
      if (isNaN(val) || val < 0) val = 1;
      updateCartItem(input.dataset.lineKey, val);
    }
    /* Gate del checkout por T&C (se re-renderiza con la sección → delegado) */
    var terms = e.target.closest('[data-cart-terms]');
    if (terms) {
      var btn = getSection().querySelector('[data-cart-checkout]');
      if (btn) btn.disabled = !terms.checked;
    }
  });
})();
